module.exports = __webpack_public_path__ + "static/media/pollution.491d56ad.jpg";